import { jsxs as o, jsx as s } from "react/jsx-runtime";
import { c as m } from "../../index-Cu0xwYjD.js";
import { toCSSLengthValue as t } from "../../utils/helpers.js";
const x = "ids-placeholder-v501", u = "ids-placeholder--transparent-v501", n = {
  placeholder: x,
  transparent: u
}, f = ({
  children: l,
  className: c,
  height: e = "auto",
  stretch: p,
  style: r,
  transparent: d,
  width: a = "auto",
  ...h
}) => {
  const i = e === "auto" ? p ? "100%" : e : t(e);
  return /* @__PURE__ */ o(
    "div",
    {
      className: m(c, n.placeholder, {
        [n.transparent]: d
      }),
      ...h,
      style: {
        ...r,
        width: a ? t(a) : r == null ? void 0 : r.width,
        height: i
      },
      children: [
        /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ s("line", { x1: "0", y1: "0", x2: "100%", y2: "100%" }),
          /* @__PURE__ */ s("line", { x1: "100%", y1: "0", x2: "0", y2: "100%" })
        ] }),
        l
      ]
    }
  );
};
export {
  f as IressPlaceholder
};
